import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import FormGroup from 'flarum/common/components/FormGroup';
import { latestBirthday } from '../utils/birthday';
export default class BirthdayField extends Component {
  view() {
    return m(FormGroup, Object.assign({
      type: "date",
      name: "birthday",
      label: app.translator.trans('datlechin-birthdays.lib.birthday_label'),
      max: latestBirthday()
    }, this.attrs));
  }
}
flarum.reg.add('datlechin-birthdays', 'common/components/BirthdayField', BirthdayField);